import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: MJS workaround to allow in JS file
import { service } from '../../client.mjs';
import { ApiResponse, AffiliateDetails } from '../../types';
import { dataOrError } from '../../utils/dataOrError';

const getAffiliateDetails = async (affiliateId: string) => {
  const { data } = await service.get<ApiResponse<AffiliateDetails>>(
    `/Entra-Affiliate/Affiliate/GetDetails?affiliateId=${affiliateId}`
  );
  return dataOrError<AffiliateDetails>(data);
};

export function useGetAffiliateDetails() {
  const [affiliateId, setAffiliateId] = useState('');
  const res = useQuery({
    queryKey: ['affiliateDetailsEntra', affiliateId],
    queryFn: () => getAffiliateDetails(affiliateId),
    enabled: !!affiliateId,
  });

  const fetchAffiliateDetails = (newAffiliateId: string) => {
    setAffiliateId(newAffiliateId);
  };

  return {
    ...res,
    fetchAffiliateDetails,
  };
}
